import React, { useState } from 'react';
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowDropup } from "react-icons/io";
import { FiSearch } from "react-icons/fi";
import { IoCloseCircleSharp } from "react-icons/io5";
import { RiCloseLargeLine } from "react-icons/ri";

const CustomDropdown = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };
  const emptySearch = () => {
    onChange("")
  }
  const closeDropDown = () => {
    setIsOpen(false)
  }
  return (
    <div className="custon_dropdown">
      <input
        type="text"
        value={value}
        onClick={() => setIsOpen(!isOpen)}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="input dropdown_input"
      />
      {isOpen ? <IoMdArrowDropup onClick={() => setIsOpen(false)} className='dropdown_arrow'/> : <IoMdArrowDropdown onClick={() => setIsOpen(true)} className='dropdown_arrow'/>}
      
      {isOpen && (
        <div className="dropdown_menu">
          <div className="dropdrown_header">
            <div className="search_container">
              <FiSearch className='search_coin_icon'/>
              <input type="text" value={value}  onChange={(e) => onChange(e.target.value)} placeholder="Search" className="input dropdown_input search_input"/>
              {value && value !== "undefined" ? <IoCloseCircleSharp onClick={() => emptySearch()} className='empty_search_icon'/> : ""}
            </div>
          <button className="btn cancel_btn" onClick={() => closeDropDown()}><RiCloseLargeLine/></button>
          </div>
          <div className="dropdown_list_container">
          {options
            .filter((option) => option.toLowerCase().includes(value.toLowerCase()))
            .map((option, index) => (
              <div
                key={index}
                className="dropdown_item"
                onClick={() => handleSelect(option)}
              >
                {option}
              </div>
            ))}
          </div>
          

        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
